// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"448":"da6d22ef","560":"45b3d990","672":"68d80295","744":"c2f4acb3","800":"f9144981"}[chunkId] + ".css";
};